import React from 'react';
import { IntlShape } from 'react-intl';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from './messages.mjs';

interface CompanyBreadcrumbsProperties {
  intl: IntlShape;
  crumbRoute: string;
  crumbLabel: string;
}

const createCompanyBreadcrumbs = ({
  intl, crumbRoute, crumbLabel,
}: CompanyBreadcrumbsProperties) => (
  [
    <HomeLink key="home" />,
    <LinkAndAnchor
      key="company"
      route="company"
      passHref
    >
      {intl.formatMessage(messages.company)}
    </LinkAndAnchor>,
    <LinkAndAnchor
      key={crumbRoute}
      route={crumbRoute}
      passHref
    >
      {crumbLabel}
    </LinkAndAnchor>,
  ]
);

export default createCompanyBreadcrumbs;
